/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { createSelector } from "reselect";
import {
  getListViewObj,
  getcompanyListViewObj,
  getAllcompanyListViewObj,
} from "./helper";

export const getCompany = (state) => state.company;
export const getCompanyLength = createSelector(
  [getCompany],
  (company) => company.list.length,
);

export const getCompanies = createSelector([getCompany], (company) =>
  company && company.list && company.list.length > 0
    ? company.list.map((comp) => getListViewObj(comp))
    : [],
);
export const getCurrentCompany = createSelector([getCompany], (company) =>
  company && company.currentCompany ? company.currentCompany : undefined,
);
export const allCompanies = createSelector([getCompany], (company) =>
  getcompanyListViewObj(company && company.all ? company.all : []),
);
export const getAllCompaniesList = createSelector([getCompany], (company) =>
  getAllcompanyListViewObj(company && company.list ? company.list : []),
);
export const getCompanySuccessResponse = createSelector(
  [getCompany],
  (company) =>
    company && company.companySuccessResponse
      ? company.companySuccessResponse
      : undefined,
);
export const getCompanyErrorResponse = createSelector([getCompany], (company) =>
  company && company.errorResponse ? company.errorResponse : undefined,
);
export const getToggleStatus = createSelector([getCompany], (company) => ({
  togglingStatus:
    company && company.togglingStatus ? company.togglingStatus : undefined,
  toggleStatusResponse:
    company && company.toggleStatusResponse
      ? company.toggleStatusResponse
      : undefined,
  toggleStatusError:
    company && company.toggleStatusError
      ? company.toggleStatusError
      : undefined,
}));
export const getCompaniesLoadingStatus = createSelector(
  [getCompany],
  (company) => ({
    loading: company && company.isLoading ? company.isLoading : false,
    loaded: company && company.isLoaded ? company.isLoaded : false,
  }),
);
export const getACompaniesLoadingStatus = createSelector(
  [getCompany],
  (company) => ({
    currenyCompanyLoading:
      company && company.currenyCompanyLoading
        ? company.currenyCompanyLoading
        : false,
    currentCompanyLoaded:
      company && company.currentCompanyLoaded
        ? company.currentCompanyLoaded
        : false,
  }),
);
export const getCompanyTotalCount = createSelector([getCompany], (company) =>
  company && company.total ? company.total : 0,
);
export const getDefaultCompany = createSelector([getCompany], (company) =>
  company && company.defaultCompany ? company.defaultCompany : null,
);

export const getCompanyFavorites = createSelector([getCompany], (company) =>
  company && company.favorites ? company.favorites : [],
);
export const getAllCompaniesLoadingStatus = createSelector(
  [getCompany],
  (company) => ({
    loading: company && company.loading ? company.loading : false,
    loaded: company && company.loaded ? company.loaded : false,
  }),
);
export const getSwitchCompany = createSelector([getCompany], (company) =>
  company && company.switchCompany ? company.switchCompany : null,
);
export const getSwitchCompanyLoadingStatus = createSelector(
  [getCompany],
  (company) => ({
    loading: company?.isSwitchCompanyLoading
      ? company.isSwitchCompanyLoading
      : false,
    loaded: company?.isSwitchCompanyLoaded
      ? company.isSwitchCompanyLoaded
      : false,
  }),
);
export const getACompanyLogs = createSelector(
  [getCompany],
  (company) => company?.logs && company?.logs?.data,
);

export const getCompanyFeatureSuccessResponse = createSelector(
  [getCompany],
  (company) =>
    company?.currentCompanyFeature ? company.currentCompanyFeature : undefined,
);
export const getCompanyDynamicSuccessResponse = createSelector(
  [getCompany],
  (company) =>
    company?.companyDynamicResponse
      ? company.companyDynamicResponse
      : undefined,
);
